import { ReactNode } from 'react';

import style from './index.module.css';

/**
 * Component that can be used with HeroPage to place additional content on the top side of the page's content.
 *
 */
export default function HeroTopContent({ children }: { children: ReactNode }) {
  return <div className={style['TopContent']}>{children}</div>;
}
